
import { HashRouter as Router, Routes, Route  } from 'react-router-dom';
import { PatientProvider } from './component/PatientContextAPI';
import { LoginProvider } from './component/LoginContext';
import RequireAuth from './component/RequireAuth';
import CheckLogin from './pages/FromMedSmart';
import LoginPage from './pages/Login';
import Worklist from './pages/Worklist';
import Teleinfo from './pages/Teleinfo';
import Telemedicine from './pages/Telemedicine';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect , useState } from 'react';


function App() {
  useEffect(() => {
      // ตรวจสอบว่า URL ไม่มี hash หรือไม่
      if (!window.location.hash) {
        const currentPath = window.location.pathname; // เก็บค่า path ที่มีหลัง domain
        const currentDomain = window.location.origin; // เก็บค่า domain
        const newUrl = `${currentDomain}/#${currentPath}`; // รวม domain กับ path พร้อม # 

        // เปลี่ยน URL และนำไปที่หน้าใหม่
        window.location.replace(newUrl); // ใช้ replace เพื่อไม่ให้เก็บ URL เก่าภายใน history
      }
    
    
  }, []);
  return (
    
    <LoginProvider>
      <PatientProvider>
        <Router>
          <Routes>
            
            <Route path="/" element={<LoginPage />} />
            <Route path="/Checklogin/:encryptedData" element={<CheckLogin/>}/>
            <Route path="/Telemedicine/:roomId/:patientId" element={<Telemedicine />}/>

            <Route path="/Worklist/:passcode" element={<RequireAuth><Worklist /></RequireAuth>} />
            <Route path="/Worklist/:passcode/:hn" element={<RequireAuth><Worklist/></RequireAuth>}/>
            <Route path="/Teleinfo/:patientAccession" element={<RequireAuth><Teleinfo /></RequireAuth>} />
            
          </Routes>
        </Router>
      </PatientProvider>
    </LoginProvider>
        
  );
}


export default App;
